import Splide from '@splidejs/splide';

const selectors = {
  carousel: '[data-splide-carousel]',
  slide: '.splide__slide',
};

export default class MainContact {
  constructor(section) {
    this.el = section.el;
    this.data = section.data || {};
    this.locationCount = this.data.locationCount || 0;
    this.carouselEl = this.el.querySelector(selectors.carousel);
    this.splide = null;

    this._init();
  }

  _init() {
    // A single location renders without a carousel — see main-contact.liquid.
    if (!this.carouselEl || this.locationCount <= 1) {
      return;
    }

    this.splide = new Splide(this.carouselEl, {
      perPage: 1,
      perMove: 1,
      gap: 0,
      // Deliberately left on the default `slide` type: no rewind, and not
      // `loop` either, since looping clones slides and the clones would
      // duplicate each block's `shopify_attributes`. Splide disables the
      // arrows at each end instead — `carousel-arrows.liquid` styles that
      // with `disabled:opacity-50`.
      autoHeight: true,
      pagination: false,
    });

    this.splide.mount();
  }

  onSectionBlockSelect({ el }) {
    if (!this.splide || !el) {
      return;
    }

    const slide = el.closest(selectors.slide);

    if (!slide) {
      return;
    }

    const slides = [...this.carouselEl.querySelectorAll(selectors.slide)];
    const index = slides.indexOf(slide);

    if (index >= 0) {
      this.splide.go(index);
    }
  }

  onSectionUnload() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
